import { render, staticRenderFns } from "./BackpackPageMobile.vue?vue&type=template&id=0f8819b2&scoped=true"
import script from "./BackpackPageMobile.vue?vue&type=script&lang=js"
export * from "./BackpackPageMobile.vue?vue&type=script&lang=js"
import style0 from "./BackpackPageMobile.vue?vue&type=style&index=0&id=0f8819b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8819b2",
  null
  
)

export default component.exports